import moment from "moment";

export function getRowId(row: any): string | number {
  const id = row?.id ?? row?.batchId;
  if (id !== null && id !== undefined && id !== "") return id;

  const oncologyBatchId = row?.oncologyBatchId;
  if (
    oncologyBatchId !== null &&
    oncologyBatchId !== undefined &&
    oncologyBatchId !== 0
  )
    return oncologyBatchId;

  if (row?.batchCode) return row.batchCode;
  if (row?._clientRowId !== null && row?._clientRowId !== undefined)
    return row._clientRowId;

  return row?.rowStatus ? "draft-new" : "unknown";
}

export function pickField(row: any, ...keys: string[]): string {
  for (const k of keys) {
    if (row?.[k] !== undefined && row?.[k] !== null && row?.[k] !== "") {
      return row[k];
    }
  }
  return "";
}

export function toRunDateQuery(date: string): string {
  return date
    ? moment.utc(date, "MM/DD/YYYY").startOf("day").toISOString()
    : "";
}

export function convertGDNAFlagToBoolean(flag: string): boolean | null {
  if (!flag || flag.trim() === "") return null;
  const upperFlag = flag.toUpperCase().trim();
  if (upperFlag === "PASS") return true;
  if (upperFlag === "FAIL") return false;
  if (["Y", "YES", "TRUE", "1", "P", "POSITIVE"].includes(upperFlag))
    return true;
  if (["N", "NO", "FALSE", "0", "NEGATIVE"].includes(upperFlag)) return false;
  return null;
}
